export default __webpack_public_path__ + "pgnv-assets/ef2849ccea574e31573162d7c9ebbb15.png";